import React from 'react'
import logo from '../../images/logo.svg'
import './AppLogo.css'

const AppLogo = () => (
  <div className="AppLogo">
    <img src={logo} className="App-logo" alt="logo" />
  </div>
)

export default AppLogo
